import React, {useState} from 'react';
import {Link, useHistory, useLocation} from "react-router-dom";
import {connect} from 'react-redux'
import {login} from './redux/actions'
import './styles/LoginPage.css';

function LoginPage(props) {
    let history = useHistory();
    let location = useLocation();
    const [formData, setFormData] = useState({'email': '', 'password': ''});

    function handleInputChange(event) {
        const target = event.target;
        const _formData = {...formData};
        _formData[target.name] = target.value;
        setFormData(_formData);
    }

    function handleLoginClick(e) {
        e.preventDefault();
        props.login(formData, from)
    }

    let {from} = location.state || {from: {pathname: "/sessions"}};

    return (
        <div className="background-image">
            <div className="container login">

                <div className="row">
                    <div className="col-md-8 col-md-offset-2">
                        <div className="javascript-required alert alert-warning lead text-center"
                             style={{display: "none"}}>
                            <p>This website requires a modern browser with javascript enabled.</p>
                            <p>Please disable any javascript blockers and/or use a different browser.</p>
                        </div>

                        <div className="panel panel-default login-area">
                            <div className="panel-heading">Login</div>
                            <div className="panel-body">
                                <form className="form-horizontal">
                                    <div className="form-group">
                                        <label htmlFor="email" className="col-md-4 control-label">E-Mail Address</label>

                                        <div className="col-md-6">
                                            <input id="email" type="email" className="form-control" name="email"
                                                   value={formData.email} onChange={handleInputChange} required=""
                                                   autoFocus=""/>

                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="password" className="col-md-4 control-label">Password</label>

                                        <div className="col-md-6">
                                            <input id="password" type="password" className="form-control"
                                                   name="password" value={formData.password}
                                                   onChange={handleInputChange} required=""/>

                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="col-md-6 col-md-offset-4">
                                            <div className="checkbox">
                                                <label>
                                                    <input type="checkbox" name="remember"/> Remember Me
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="col-md-8 col-md-offset-4">
                                            <button className="btn btn-primary"
                                                    onClick={handleLoginClick}>
                                                Login
                                            </button>

                                            <a className="btn btn-link">
                                                <Link to="/password/forgot">Forgot password?</Link>
                                            </a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    null,
    {login}
)(LoginPage)
